import { formatDate } from 'helper/dateFormat';
import moment from 'moment';
import React from 'react';
const NewEventSuccessTask = ({getCardColor,index,item}) => {



  const randomColor = getCardColor(item?.unit, item?.recurring);


  return (
    <li className="event-tasks__container__item" style={{backgroundColor: randomColor.bgColor, color: randomColor.textColor}}>
      <div className="event-tasks__container__item-period">
        {item?.displayText}
      </div>
      {(item?.recurring === 0 && item?.dateCalculated) && (
        <span className="event-tasks__container__item-date">
          {formatDate({date: item?.dateCalculated, formatType: "defaultWithUTC"})}
        </span>
      )}
    </li>
  )
}

export default NewEventSuccessTask